import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AdminSubpage from '../components/AdminSubpage';
import ReservationDetails from '../components/ReservationDetails';
import { reservationsAPI } from '../services/api';
const ReservationDetailPage = () => {
  const { reservationId } = useParams();
  const navigate = useNavigate();
  const [reservation, setReservation] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!reservationId) return;
    setLoading(true);
    try {
      const response = await reservationsAPI.getById(reservationId);
      setReservation(response.data.reservation ?? null);
      if (!response.data.reservation) {
        toast.error('Could not load reservation.');
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || error.message || 'Error loading reservation',
      );
      setReservation(null);
    } finally {
      setLoading(false);
    }
  }, [reservationId]);

  useEffect(() => {
    void load();
  }, [load]);

  const title = reservation?.product?.title
    ? `Reservation — ${reservation.product.title}`
    : 'Reservation details';

  return (
    <AdminSubpage title={title} backTo="/reservations">
      {loading ? (
        <div className="loading">Loading reservation…</div>
      ) : reservation ? (
        <ReservationDetails
          reservation={reservation}
          onUpdated={(updated) => setReservation(updated)}
          onDeleted={() => navigate('/reservations')}
        />
      ) : (
        <p>No reservation loaded.</p>
      )}
    </AdminSubpage>
  );
};

export default ReservationDetailPage;
